import useController from "@hooks/useController"

export default function useSocialiteController(): Auth.Controllers.Socialite {
    const controller = useController('/api/auth')

    const redirect = (service: string) => controller.get(`${service}/redirect`)

    return { redirect }
}